export interface AuctionsOptions {
  ethereumValue: number;
  blockTimestamp: number;
  transform?: (auction: any) => void;
}

export type AuctionOptions = AuctionsOptions;

export enum AuctionStatus {
  OPEN = 'Open',
  ENDED = 'Ended',
  CANCELED = 'Canceled',
  FINALIZED = 'Finalized',
}

export enum AuctionType {
  BUYNOW = 'BuyNow',
  TRADITIONAL = 'Traditional',
}
